export default __webpack_public_path__ + "static/media/laundry2-beforeB-768w.9b910277.webp";